export const ListQueryKey = 'cultures';
export const DetailQueryKey = 'culture';

export const Urls = {
  selectUrl: '/culture/list',
  updateUrl: '/culture/update',
  deleteUrl: '/culture/delete',
  createUrl: '/culture/create',
  detailUrl: '/culture/detail',
};
